module.exports = __webpack_public_path__ + "static/media/CONTRATO PROFECO 3 servicios 233-2020.974570f8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CONTRATO PROFECO 3 servicios 233-2020.pdf
// module id = 353
// module chunks = 0